/* ZWIM Triathlon Swim Readiness Score — external (deferred). buildInputs() once; compute() on input/change. compute NEVER rewrites inputs. */
(function(){
  var app=document.getElementById('ztf-app'); if(!app) return;
  var $=function(id){return document.getElementById(id);};
  var RACE={sprint:750,olympic:1500,half:1900,full:3800};
  var I='inputmode="numeric" autocomplete="off" min="0"';

  function num(id){var e=$(id); if(!e) return 0; var v=parseFloat(e.value); if(!isFinite(v)||v<0) v=0; return v;}
  function val(id){var e=$(id); return e?e.value:'';}

  function setHero(score){
    var b=$('ztf-big');
    if(b.firstChild && b.firstChild.nodeType===3){
      if(b.firstChild.nodeValue!==(''+score)){
        b.firstChild.nodeValue=''+score;
        b.classList.add('pulse'); setTimeout(function(){b.classList.remove('pulse');},180);
        if(window.__zwimTrack)window.__zwimTrack('tool_calc_run',{tool:'readiness',score:score});
      }
    } else { b.insertBefore(document.createTextNode(''+score), b.firstChild); }
    $('ztf-cap').textContent='Your swim readiness';
    $('ztf-bigunit').textContent='/ 100';
  }
  function chips(arr){return '<div class="ztf__chips">'+arr.map(function(c){return '<div class="ztf__chip'+(c.cls?' '+c.cls:'')+'"><div class="k">'+c.k+'</div><div class="v">'+c.v+'</div></div>';}).join('')+'</div>';}

  function buildInputs(){
    var inp=$('ztf-inputs');
    inp.innerHTML=
      '<div class="ztf__f"><label>Race distance</label><select id="i-race">'+
        '<option value="sprint">Sprint (750m)</option>'+
        '<option value="olympic" selected>Olympic (1500m)</option>'+
        '<option value="half">70.3 (1900m)</option>'+
        '<option value="full">Ironman (3800m)</option>'+
      '</select></div>'+
      '<div class="ztf__f"><label>Longest non-stop swim (m)</label><input id="i-long" value="1000" '+I+'></div>'+
      '<div class="ztf__f"><label>Swims per week</label><input id="i-freq" value="2" '+I+'></div>'+
      '<div class="ztf__f"><label>Open-water sessions done</label><input id="i-ow" value="1" '+I+'></div>'+
      '<div class="ztf__f"><label>Sighting confidence</label><select id="i-sight">'+
        '<option value="low">Low</option><option value="med" selected>Medium</option><option value="high">High</option>'+
      '</select></div>'+
      '<div class="ztf__f"><label>Weeks until race</label><input id="i-wks" value="8" '+I+'></div>'+
      '<div class="ztf__f"><label>Swim anxiety</label><select id="i-anx">'+
        '<option value="low">Low</option><option value="med" selected>Medium</option><option value="high">High</option>'+
      '</select></div>';
    // style selects to match the dark inputs
    inp.querySelectorAll('select').forEach(function(s){
      s.style.cssText='width:100%;background:rgba(0,0,0,.4);border:1px solid var(--line-2);border-radius:var(--r-lg);color:#fff;padding:14px;font-family:"ZWIM Wide","ZWIM Body",sans-serif;font-weight:800;font-size:15px;letter-spacing:-.01em;text-align:center;text-align-last:center;cursor:pointer;-webkit-appearance:none;appearance:none';
    });
    inp.querySelectorAll('input,select').forEach(function(e){
      e.addEventListener('input',compute); e.addEventListener('change',compute);
    });
  }

  function compute(){
    var race=RACE[val('i-race')]||1500;
    var longest=num('i-long');
    var freq=num('i-freq');
    var ow=num('i-ow');
    var sight=val('i-sight');
    var wks=num('i-wks');
    var anx=val('i-anx');

    // Endurance (max 30)
    var endurance=Math.min(30, Math.round((longest/race)*30));
    // Consistency (max 25)
    var consistency = freq>=4?25 : freq>=3?20 : freq>=2?13 : freq>=1?6 : 0;
    // Open-water (max 20)
    var openwater = ow>=4?20 : ow>=3?16 : ow>=2?11 : ow>=1?6 : 0;
    // Sighting (max 10)
    var sighting = sight==='high'?10 : sight==='med'?6 : 2;
    // Composure (max 15) — anxiety Low 15 / Medium 9 / High 3
    var composure = anx==='low'?15 : anx==='med'?9 : 3;

    var total=endurance+consistency+openwater+sighting+composure;
    if(total<0)total=0; if(total>100)total=100;
    setHero(total);

    // Tier
    var tier, tierCls;
    if(total<50){ tier='Build the base'; tierCls='tier-low'; }
    else if(total<75){ tier='Getting race-ready'; tierCls='tier-mid'; }
    else { tier='Race-ready'; tierCls='tier-high'; }

    // Weakest limiter = component with lowest score/max ratio
    var comps=[
      {name:'Endurance', score:endurance, max:30},
      {name:'Consistency', score:consistency, max:25},
      {name:'Open-water practice', score:openwater, max:20},
      {name:'Sighting', score:sighting, max:10},
      {name:'Composure', score:composure, max:15}
    ];
    var weakest=comps[0], wr=comps[0].score/comps[0].max;
    for(var i=1;i<comps.length;i++){ var r=comps[i].score/comps[i].max; if(r<wr){ wr=r; weakest=comps[i]; } }

    $('ztf-extra').innerHTML=chips([
      {k:'Tier', v:tier, cls:tierCls},
      {k:'Weakest limiter', v:weakest.name},
      {k:'Weeks left', v:wks>0?Math.round(wks):'--'}
    ]);

    var FOCUS={
      'Endurance':'Next 2 weeks: build one longer continuous swim each week, edging toward your full race distance non-stop.',
      'Consistency':'Next 2 weeks: lock in one more swim per week, even a short one, so your body keeps adapting.',
      'Open-water practice':'Next 2 weeks: get at least one calm open-water session in, close to shore, to build real comfort.',
      'Sighting':'Next 2 weeks: add sighting practice, lifting your eyes every 6 to 8 strokes to swim straight without a black line.',
      'Composure':'Next 2 weeks: rehearse a controlled, slow-breathing start so a crowded, choppy swim stays calm.'
    };
    var urgency='';
    if(wks>0){
      if(wks<=3) urgency='Only '+Math.round(wks)+' weeks left, so keep it simple and prioritize this now. ';
      else if(wks>=12) urgency='With '+Math.round(wks)+' weeks to go, you have time to build the base properly. ';
    }
    $('ztf-hint').textContent=urgency+FOCUS[weakest.name]+' This score is an educational estimate, not safety advice.';
  }

  buildInputs(); compute();
})();
